import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  materialList: []
};

export default function visaMaterialList(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 获取签证材料清单
    case ACTION_TYPES.GET_VISA_MATERIAL_LIST:
      result.materialList = payload;
      break;
    default:
      result = state;
  }
  return result;
}
